import Image from 'next/image';
import type { FC } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
const HomePageQuestionRight: FC = () => {
  return <div className="  order-0 relative my-6 mr-6 flex min-h-full flex-col items-start  sm:mb-0 lg:order-2 lg:items-start" data-sentry-component="HomePageQuestionRight" data-sentry-source-file="HomePageQuestionRight.tsx">
      <div className="leading-5 text-md w-full max-w-[265px] py-2 pl-4 font-pelak font-bold text-blueFive">
        سوالاتی که شما پرسیدین...
      </div>

      <p className="mb-4 ">
        <span className="text-lg font-bold text-blueFive sm:text-xl md:text-2xl lg:text-3xl">جواب همۀ سوالات اینجاست!</span>
      </p>
      <div className="absolute -top-3 left-0 max-w-[130px] self-end sm:static sm:-mt-32 sm:max-w-[200px] md:-mt-40 md:max-w-[300px] lg:-mb-6 lg:mt-0 lg:w-auto lg:max-w-[430px] lg:self-auto">
        <Image width={512} height={584} src={`${FILE_BROWSER_URL}/img/question_person.png`} alt="عکس در حال جستجو" data-sentry-element="Image" data-sentry-source-file="HomePageQuestionRight.tsx" />
      </div>
    </div>;
};
export default HomePageQuestionRight;